import locationsList from '../static-content/locale-menu.json';

export const isContentExcluded = (content, space, regionalContent) => {
  // Find the location matching the current space URL and get its exclusion flag
  const location = locationsList.locations.find(location => location.url === space);
  const exclusionFlag = location?.exclusion_flag;
  // ExclusionList is not required to publish content, this checks to see if it exists
  const exclusionList = content?.exclusionList ? content?.exclusionList[exclusionFlag] : false;

  return (exclusionList && !regionalContent);
};
